import { itiHttpService, itiMessageService, itiTokenService } from '@/iti-core-vue';
import { ItiIconButton, ItiVHeader, ItiList } from '@/iti-core-vuetify';
import { Component, Vue } from "vue-property-decorator";
import DxButton from 'devextreme-vue/button';
import DxDataGrid, {DxColumn, DxPaging} from 'devextreme-vue/data-grid';
import offerDemandModule from '@/store/modules/offer-demand.module';

@Component({
    components: {    
      ItiIconButton,       
      DxButton,     
      DxDataGrid,
      DxColumn,
      DxPaging,
    }
  })

export default class OffersDemandsList extends Vue {

  public loading = false;
  public search = '';
  
  public get headers() {
    return [
      new ItiVHeader('description', 'offers-demands.description'),
      new ItiVHeader('type', 'offers-demands.type'),
      new ItiVHeader('categoryFirstLevelDescription', 'offers-demands.category1'),
      new ItiVHeader('categorySecondLevelDescription', 'offers-demands.category2'),
      new ItiVHeader('categoryThirdLevelDescription', 'offers-demands.category3'),
      new ItiVHeader('categoryFourthLevelDescription', 'offers-demands.category4'),
      new ItiVHeader('hasSynergies', 'offers-demands.hasSynergies'),
      new ItiVHeader('action', ''),
    ];
  }
  
  public get offersDemands() {
    return offerDemandModule.offerDemandList;
  } 

  public mounted() {
    offerDemandModule.getOfferDemandList().catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
  }

  public showItem(e: any) {
      this.$router.push({ name: 'MatchingOferta_Demanda', params: { id: e.id, type: e.type } });
  }

  public formattedContent(contenido: string) {
    if (contenido && contenido.length > 40) {
        return String(contenido).substring(0, 40) + "...";
    } else {
        return contenido;
    }
  }

  public translateType(type: string) {
    if (type == "offer") {
      return this.$tc('offers-demands.offer');
    } else if (type == "demand") {
      return this.$tc('offers-demands.demand');
    } else {
      return type;
    }
  }

  public newItem() {
    this.$router.push({ name: 'OfertaDemandaFormulario' })
  }

}